import { Link } from "react-router-dom";
import "../styles/services.css";

export default function Services() {
  const services = [
    {
      name: "Bike Rental in Udaipur",
      image:
        "https://apnamechanic.com/blog/wp-content/uploads/2022/06/bullet-service-online-1024x683-1.jpg",
      alt: "Motorcycle available for rent in Udaipur",
      description:
        "Rent motorcycles in Udaipur for city exploration, sightseeing and selected outstation trips.",
      price: "Check current rental prices",
      link: "/bikes",
      button: "View Bikes",
    },

    {
      name: "Scooty Rental in Udaipur",
      image:
        "https://cdn.bikedekho.com/upload/userreviewimages/695cac9a503d9.jpg",
      alt: "Scooty available for rent in Udaipur",
      description:
        "Choose a convenient scooty for exploring Udaipur and getting around the city.",
      price: "Check current rental prices",
      link: "/bikes",
      button: "View Scooters",
    },

    {
      name: "Sedan Taxi in Udaipur",
      image:
        "https://media-cdn.tripadvisor.com/media/attractions-splice-spp-674x446/17/0f/6e/f8.jpg",
      alt: "Sedan taxi available for travel in Udaipur",
      description:
        "AC sedan taxi options for airport transfers, local sightseeing and other travel requirements.",
      price: "From ₹12/km",
      link: "/taxi",
      button: "View Taxi Services",
    },

    {
      name: "SUV Taxi in Udaipur",
      image:
        "https://5.imimg.com/data5/SELLER/Default/2025/1/483658830/QC/ZU/AJ/106361149/rajasthan-taxi-service-500x500.jpg",
      alt: "SUV taxi available for travel in Udaipur",
      description:
        "Spacious SUV options for families, groups, sightseeing and selected outstation journeys.",
      price: "From ₹18/km",
      link: "/taxi",
      button: "View SUV Options",
    },
  ];

  return (
    <section
      className="services-section"
      aria-labelledby="services-title"
    >
      {/* =====================================================
          SECTION HEADER
      ====================================================== */}

      <header className="services-header">

        <h2
          id="services-title"
          className="services-title"
        >
          Bike, Scooty & Taxi Rental Services in Udaipur
        </h2>

        <p className="services-intro">
          Choose a bike, scooty or taxi for exploring Udaipur.
          View available vehicles and contact VK Bike On Rent
          to confirm current availability and rental pricing.
        </p>

      </header>

      {/* =====================================================
          SERVICES GRID
      ====================================================== */}

      <div className="services-grid">

        {services.map((service) => (
          <article
            className="service-card"
            key={service.name}
          >

            {/* Image */}

            <div className="service-image-wrapper">

              <img
                src={service.image}
                alt={service.alt}
                className="service-image"
                width="600"
                height="400"
                loading="lazy"
                decoding="async"
              />

            </div>

            {/* Content */}

            <div className="service-content">

              <h3>
                {service.name}
              </h3>

              <p>
                {service.description}
              </p>

              <p className="price">
                {service.price}
              </p>

              <Link
                to={service.link}
                className="service-btn"
                aria-label={`${service.button} - ${service.name}`}
              >
                {service.button}
              </Link>

            </div>

          </article>
        ))}

      </div>
    </section>
  );
}